import { IPatientService } from "../IPatientService";
import { Patient, PatientDetails, NewPatient } from "../../types";

export class PatientMockService implements IPatientService {
  async getPatients(): Promise<Patient[]> {
    const response = await fetch("/mocks/patients/patients-list.json");
    return response.json();
  }

  async getPatientDetails(patientId: string): Promise<PatientDetails> {
    const response = await fetch(`/mocks/patients/patient-${patientId}.json`);
    return response.json();
  }

  async createPatient(patient: NewPatient): Promise<Patient> {
    // Return a mock patient with a random ID
    return { ...patient, id: `P${Math.floor(Math.random() * 10000)}` } as Patient;
  }

  async getPatientBloodGlucose(patientId: string, days: number = 7) {
    const response = await fetch(`/mocks/patients/metrics/${patientId}-blood-glucose.json`);
    return response.json();
  }

  async getPatientWeight(patientId: string, days: number = 7) {
    const response = await fetch(`/mocks/patients/metrics/${patientId}-weight.json`);
    return response.json();
  }

  async getPatientCalories(patientId: string, days: number = 7) {
    const response = await fetch(`/mocks/patients/metrics/${patientId}-calories.json`);
    return response.json();
  }

  async getPatientActivity(patientId: string, days: number = 7) {
    const response = await fetch(`/mocks/patients/metrics/${patientId}-activity.json`);
    return response.json();
  }
}
